import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  TextField,
  Tooltip,
} from '@mui/material';
import { getUser } from 'API';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import {
  useDictionary,
  useDispatchApp,
  useImposter,
  useIsDesktop,
} from 'Hooks';
import { useCallback, useEffect, useRef, useState } from 'react';
import {
  setImposterId,
  setIsAdmin,
  setFakeUser,
  setUser,
  setIsReadNotifications,
} from 'Store/ImposterSlice';

export const UserInfo = () => {
  const generalDictionary = useDictionary(Dictionary, DICTIONARY.General);
  const [input, setInput] = useState<string>('');
  const [isHidden, setIsHidden] = useState<boolean>(false);
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.General);

  const dispatch = useDispatchApp();

  const { authenticatedUser, imposterId, isAdmin } = useImposter();

  const [selectId, setSelectId] = useState<string>('');

  const handleChange = (event: SelectChangeEvent) => {
    setSelectId(event.target.value);
    onChangeHandler(event.target.value);
  };

  const fakeIds = [
    '037637279',
    '021716477',
    '051827178',
    '2213593',
    '51796472',
    '350488',
    '02662799',
    '73379547',
    '56075070',
    '71375331',
    '308471200',
    '327146577',
    '302536016',
    '64902737',
    '24252462',
    '23321672',
    '59310920',
    '200691988',
    '16702854',
    '207919234',
    '59246496',
    '57155129',
    '55997555',
    '51782662',
    '302536032',
  ];

  const firstRender = useRef<boolean>(true);

  const initUser = useCallback(async () => {
    const userData = await getUser();
    if (userData) {
      if (firstRender.current) {
        dispatch(setIsAdmin(userData.isAdminAuthenticatedUser));
      }
      dispatch(setUser(userData.authenticatedUser));
      dispatch(setIsReadNotifications(userData.hasUnreadedNotifications));
      if (imposterId && userData.fakeUser) {
        dispatch(setFakeUser(userData.fakeUser));
      }
    }
    firstRender.current = false;
  }, [dispatch, imposterId]);

  useEffect(() => {
    initUser();
  }, [imposterId, initUser]);

  const onChangeHandler = (id: string) => {
    if (id) {
      setInput(id);
    } else {
      setInput('');
    }
  };

  const onClickHandler = () => {
    if (input) {
      dispatch(setImposterId(input));
    } else {
      dispatch(setImposterId(''));
    }
  };

  if (!authenticatedUser) return null;
  return (
    <>
      <Stack
        sx={{
          width: '100%',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'center',
          margin: '0 auto',
          display: isHidden ? 'none' : undefined,
          zIndex: 999,
        }}
      >
        {process.env.NODE_ENV === 'development' && (
          <Grid
            container
            justifyContent='center'
            sx={{ top: '-5px', right: '-15px', position: 'relative' }}
          >
            <FormControl variant='outlined' sx={{ minWidth: 120 }}>
              <InputLabel id='demo-simple-select-standard-label'>
                fake ids
              </InputLabel>
              <Select
                labelId='demo-simple-select-helper-label'
                id='demo-simple-select-helper'
                value={selectId}
                label='Age'
                onChange={handleChange}
                sx={{
                  '& .MuiSelect-select': {
                    padding: '12px',
                    background: 'white',
                  },
                }}
                MenuProps={{
                  sx: {
                    maxHeight: isDesktop ? '600px' : '300px',
                    zIndex: 10000,
                  },
                }}
                type='number'
              >
                <MenuItem value=''>
                  <em>None</em>
                </MenuItem>
                {fakeIds.map((fakeId) => (
                  <MenuItem value={fakeId} key={fakeId}>
                    {fakeId}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
        {isAdmin && (
          <>
            <TextField
              size='small'
              onChange={(e) => {
                onChangeHandler(e.target.value);
              }}
              InputProps={{
                sx: {
                  background: 'white',
                },
              }}
            />
            <Button
              variant='contained'
              size='small'
              sx={{ height: '42px', ml: 1 }}
              onClick={() => {
                onClickHandler();
              }}
            >
              {generalDictionary.imposter}
            </Button>
          </>
        )}
        {process.env.NODE_ENV === 'development' && isAdmin && (
          <Box mt='5px' ml='5px'>
            <Tooltip title={dictionary.hideImpersonationTooltip} arrow>
              <Button
                variant='outlined'
                sx={{
                  width: '100px',
                  whiteSpace: 'nowrap',
                  background: 'white',
                }}
                onClick={() => setIsHidden(true)}
              >
                {dictionary.hideImpersonation}
              </Button>
            </Tooltip>
          </Box>
        )}
      </Stack>
    </>
  );
};
